<template>
  <ol class="ios-steps">
    <li v-for="(step, index) in steps" :key="index" class="ios-steps__item">
      <!-- O numero e a linha formam um trilho: a figura, quando existe, entra
           ABAIXO do proprio passo em vez de disputar a linha com o texto. -->
      <div class="ios-steps__rail">
        <span class="ios-steps__number">{{ index + 1 }}</span>
        <span v-if="index < steps.length - 1" class="ios-steps__line"></span>
      </div>
      <div class="ios-steps__body">
        <p v-html="step.text"></p>
        <div
          v-if="step.illustration"
          class="ios-steps__figure"
          v-html="step.illustration"
        ></div>
      </div>
    </li>
  </ol>
</template>

<script>
// O menu de compartilhar do Safari tem dezenas de itens, e o texto sozinho não
// acha nenhum: cada passo mostra onde tocar. As ilustrações são desenhadas aqui
// em vez de virarem imagens porque precisam acompanhar o tema e não pesar no
// carregamento de uma tela que só o iPhone vê.
const SHARE_ICON = `
  <svg viewBox="0 0 220 120" role="img" aria-label="Barra inferior do Safari com o botão Compartilhar em destaque">
    <rect x="6" y="6" width="208" height="108" rx="12" fill="#f3f4f6" />
    <rect x="18" y="20" width="184" height="52" rx="8" fill="#ffffff" />
    <rect x="34" y="38" width="120" height="8" rx="4" fill="#d1d5db" />
    <rect x="18" y="84" width="184" height="20" rx="10" fill="#ffffff" />
    <circle cx="110" cy="94" r="18" fill="currentColor" opacity="0.14" />
    <path d="M110 86v14M110 86l-5 5M110 86l5 5M101 96v6h18v-6" stroke="currentColor" stroke-width="2.4"
      stroke-linecap="round" stroke-linejoin="round" fill="none" />
    <rect x="46" y="88" width="14" height="12" rx="3" fill="#d1d5db" />
    <rect x="160" y="88" width="14" height="12" rx="3" fill="#d1d5db" />
  </svg>
`;

const MENU_ITEM = `
  <svg viewBox="0 0 220 120" role="img" aria-label="Menu do Safari com a opção Adicionar à Tela de Início em destaque">
    <rect x="6" y="6" width="208" height="108" rx="12" fill="#f3f4f6" />
    <rect x="18" y="16" width="184" height="22" rx="6" fill="#ffffff" />
    <rect x="30" y="24" width="90" height="6" rx="3" fill="#d1d5db" />
    <rect x="18" y="44" width="184" height="22" rx="6" fill="#ffffff" />
    <rect x="30" y="52" width="70" height="6" rx="3" fill="#d1d5db" />
    <rect x="18" y="72" width="184" height="26" rx="6" fill="currentColor" opacity="0.12" />
    <rect x="30" y="82" width="118" height="7" rx="3.5" fill="currentColor" />
    <rect x="170" y="79" width="18" height="14" rx="3" fill="none" stroke="currentColor" stroke-width="2" />
    <path d="M179 82v8M175 86h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
`;

// Os passos 3, 4 e 5 nao tem ilustracao: o texto deles ja localiza a acao,
// e cinco figuras fazem a tela virar um rolo -- quanto mais rolagem, menos
// gente chega ao passo 5, que e onde a permissao e concedida.

export default {
  name: "IosInstallSteps",
  data() {
    return {
      steps: [
        {
          text: "Toque no botão <b>Compartilhar</b> do Safari — o quadrado com a seta para cima, na barra de baixo.",
          illustration: SHARE_ICON,
        },
        {
          text: "Role a lista e escolha <b>Adicionar à Tela de Início</b>.",
          illustration: MENU_ITEM,
        },
        {
          text: "Toque em <b>Adicionar</b>, no canto superior direito.",
        },
        {
          text: "Feche o Safari e abra a Recrutei pelo <b>ícone novo</b>.",
        },
        {
          text: "Volte a esta tela e toque em <b>Ativar avisos</b>.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.ios-steps {
  list-style: none;
  margin: 0;
  padding: 0;

  &__item {
    display: flex;
    gap: 14px;
  }

  // Trilho: o numero ancora, a linha liga um passo ao seguinte.
  &__rail {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
  }

  &__number {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    border-radius: 50%;
    // Acompanha a cor da empresa, como o resto do convite.
    color: var(--push-icon-color, #1551b1);
    background: var(--push-icon-bg, rgba(21, 81, 177, 0.12));
  }

  &__line {
    flex: 1;
    width: 2px;
    margin: 6px 0;
    background: #ececec;
  }

  &__body {
    flex: 1;
    min-width: 0;
    padding-bottom: 16px;

    p {
      margin: 0;
      font-size: 15px;
      line-height: 1.5;
      color: #333333;
    }
  }

  &__item:last-child &__body {
    padding-bottom: 0;
  }

  // A figura ocupa a largura do texto, e nao uma coluna estreita ao lado dele.
  &__figure {
    margin-top: 8px;
    // O destaque das ilustracoes acompanha a empresa, como o numero do passo.
    // Elas pintam com `currentColor` e herdam daqui: `var()` dentro de atributo
    // de apresentacao (`fill="var(...)"`) nao e substituido em todo navegador,
    // e o Safari e justamente o unico que ve esta tela.
    color: var(--push-icon-color, #1551b1);

    ::v-deep svg {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 10px;
    }
  }
}
</style>
